import { useEffect, useState } from 'react'

import { isAnonymousRoute } from 'utils/isAnonymousRoute'
import { setUserForDatadog } from 'utils/sdks/datadog'
import { switchLanguage } from 'utils/sdks/localize'
import { getUserInfo } from 'utils/userInfo'

import { useViewingAccountUserQuery } from 'hooks/useViewingAccountInfo'

import { useAuth } from '../context/AuthProvider'

export function useFetchCurrentUser() {
  const { isInitialized } = useAuth()
  const [userInfo, setUserInfo] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const { userDataFromQuery, loading: loadingUserInfo } =
    useViewingAccountUserQuery()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const parsedUserInfo = getUserInfo(userDataFromQuery)
        setUserForDatadog({
          userId: parsedUserInfo?.userId,
          accountId: parsedUserInfo?.account?.accountId,
        })
        switchLanguage(parsedUserInfo.displayLanguage)
        setUserInfo(parsedUserInfo)
        setLoading(false)
      } catch (error) {
        if (!isAnonymousRoute()) {
          // FIXME: should we redirect to login page?
          setError(true)
        } else {
          const parsedUserInfo = getUserInfo(userDataFromQuery)
          setUserInfo(parsedUserInfo)
        }
        setLoading(false)
      }
    }
    if (isInitialized && !loadingUserInfo) {
      fetchData()
    }
  }, [isInitialized, userDataFromQuery, loadingUserInfo])

  return { userInfo, loading, error }
}
